import { validationUtils } from "@zickko/shared";
import { Result } from "nutso";
import * as React from "react";

export type TextInputProps = {
  type?: "password" | "tel" | "email";
  value?: string;
  onChange: (value: string) => void;
  validation?: Result<string>;
  disabled?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  dataCy?: string;
  pattern?: string;
  prependText?: string;
  inputMode?: "tel" | "email" | "search" | "text";
  onPressEnter?: () => void;
  onFocus?: () => void;
  onBlur?: (value: string) => void;
  customRef?: React.RefObject<HTMLInputElement>;
  maxLength?: number;
  showClearIcon?: boolean;
};

export const TextInput = (props: TextInputProps) => {
  //
  const { validation = validationUtils.success } = props;

  return (
    <div className={`text-input ${!!props.prependText ? "has-prepend" : ""}`}>
      {props.prependText && <div className="prepend-text">{props.prependText}</div>}
      <input
        ref={props.customRef}
        type={props.type ?? "text"}
        inputMode={props.inputMode || "text"}
        maxLength={props.maxLength}
        value={props.value ?? ""}
        onChange={(e) => props.onChange(e.target.value)}
        className={validation.isValid ? "valid" : "invalid"}
        disabled={props.disabled}
        readOnly={props.readOnly}
        placeholder={props.placeholder}
        data-cy={props.dataCy}
        pattern={props.pattern}
        onFocus={props.onFocus}
        onBlur={(e) => props.onBlur && props.onBlur(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && props.onPressEnter) {
            props.onPressEnter();
          }
        }}
      />
      {/* {props.type === "password" && (
        <span className="show-password" onClick={() => setInputType(inputType === "password" ? "text" : "password")}>
          {inputType === "password" ? "SHOW" : "HIDE"}
        </span>
      )} */}
      {!props.disabled && props.showClearIcon && (
        <div className="clear-icon" onClick={() => props.onChange("")}>
          <img src="/images/icon-clear-text-field.svg" alt="clear" />
        </div>
      )}
    </div>
  );
};
